module.exports = __webpack_public_path__ + "img/banner_2026_syoukai.276ef5b1.jpg";